var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.2,
    height: 33.285,
    viewBox: "0 0 36.2 33.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_11012",
    x: 0,
    y: 0,
    width: 36.2,
    height: 33.285,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9044",
    "data-name": "Group 9044",
    transform: "translate(-1889.88 -3621.138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1889.88, 3621.14)",
    filter: "url(#Path_11012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11012-2",
    "data-name": "Path 11012",
    d: "M-2103.521,4320.423a1.6,1.6,0,0,1-1.6-1.6v-9.243a1.6,1.6,0,0,1,1.6-1.6h3.083l.4-1.987a1.07,1.07,0,0,1,1.046-.857h5.95A1.07,1.07,0,0,1-2092,4306l.4,1.987h3.081a1.6,1.6,0,0,1,1.6,1.6v9.243a1.6,1.6,0,0,1-1.6,1.6Zm3.554-6.221a3.951,3.951,0,0,0,3.947,3.946,3.95,3.95,0,0,0,3.946-3.946,3.951,3.951,0,0,0-3.946-3.946A3.951,3.951,0,0,0-2099.967,4314.2Zm1.068,0a2.882,2.882,0,0,1,2.879-2.878,2.882,2.882,0,0,1,2.879,2.878,2.882,2.882,0,0,1-2.879,2.88A2.882,2.882,0,0,1-2098.9,4314.2Z",
    transform: "translate(2114.12 -4299.14)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCamera);
export default __webpack_public_path__ + "static/media/file-camera.f8edc1f37c4d7560bfc4929644653a6b.svg";
export { ForwardRef as ReactComponent };